export class ScreenSizeService {

    public static MOBILE_SCREEN_WIDTH   = 736;
    public static MOBILE_ROUTE_PATH     = 'mobile';

    private static instance = new ScreenSizeService();
    private _isMobileScreen: boolean;

    public static getInstance() {
        return this.instance;
    }

    private constructor() {
        this._isMobileScreen = false;
    }

    public setMobileLayout() {
        this._isMobileScreen = true;
    }

    public setDesktopLayout() {
        this._isMobileScreen = false;
    }

    public get isMobileScreen() {
        return this._isMobileScreen;
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/screen-size.service.ts